import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getDetailCampaignStart,
  getDetailCampaignSuccess,
  getDetailCampaignFailed,
} from "../redux/getDetailCampaign";
import { getDetailCampaignApi } from "core/http/service/evaluation";

function* getDetailCampaignWork(
  action: ReturnType<typeof getDetailCampaignStart>
) {
  const payload = action.payload;

  try {
    const res = yield call(getDetailCampaignApi, payload);
    yield put({
      type: getDetailCampaignSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDetailCampaignFailed.type,
    });
  }
}

function* watchGetDetailCampaign() {
  yield takeLatest(getDetailCampaignStart.type, getDetailCampaignWork);
}

export default function* getDetailCampaignSaga() {
  yield all([watchGetDetailCampaign()]);
}
